import React from "react";
import RefLastResults from "../resultui/resultPoker/RefLastResults";
import RouletteResultBody from "../../casinoComponents/refResultModal/RouletteResultBody";

// Reference LastResultsSection getRouletteColor: red / black arrays, 0 → green
const RED = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
const BLACK = [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35];
const color = (win) => {
  const n = Number(win);
  return RED.includes(n) ? "red" : BLACK.includes(n) ? "black" : n === 0 ? "green" : "";
};

// Reference: <span class="result {color}">\n        {win}\n      </span>
const item = (win) => ({ cls: `result ${color(win)}`.trim(), text: `\n        ${win}\n      ` });

/** Last Result items + result modal for the roulettes, reference markup. */
export default function ResultRoulette({ gameType, data = [], title }) {
  return (
    <RefLastResults
      apiType={gameType}
      data={data}
      item={item}
      renderBody={(t1) => <RouletteResultBody t1={t1} />}
      fallbackTitle={title}
    />
  );
}
